import IDirectionsCalculator from '@/factories/directionsCalculator/IDirectionsCalculator'
import GoogleDirectionsCalculatorApi from '@/api/googleMaps/GoogleDirectionsCalculatorApi'

import MapDirections from '@/domain/MapDirections'

export default class GoogleDirectionsCalculator extends IDirectionsCalculator {
  constructor() {
    super()
    this.googleDirectionsCalculatorApi = GoogleDirectionsCalculatorApi.getInstance()
  }

  async calculateDirections() {
    const directions = await this.googleDirectionsCalculatorApi.execute({
      origin: this.mapLocation(this.origin),
      destination: this.mapLocation(this.destination)
    })

    return MapDirections.mapFromGoogleResult(directions)
  }

  mapLocation(location) {
    return new window.google.maps.LatLng(location.latitude, location.longitude)
  }
}
